module.exports = __webpack_public_path__ + "media/images/redesign-images/ma/custom-grid-02-8297c95b193d9ea981cf75377bdd96b7.jpg";